module.exports = __webpack_public_path__ + "img/mat.e539a2e0.jpg";